module.exports = __webpack_public_path__ + "img/img-archive04.8fb83357.png";